import { useTranslation } from "react-i18next";

export default function useText(ns = "studioWeb") {
	return useTranslation().t;
}
